import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext();

export function useToast() {
    return useContext(ToastContext);
}

export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);

    const addToast = useCallback((message, type = 'info') => {
        const id = Date.now();
        setToasts((prev) => [...prev, { id, message, type }]);
        setTimeout(() => {
            setToasts((prev) => prev.filter((toast) => toast.id !== id));
        }, 3000);
    }, []);

    return (
        <ToastContext.Provider value={{ addToast }}>
            {children}
            <div style={{
                position: 'fixed',
                top: 16,
                right: 16,
                zIndex: 9999,
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
            }}>
                {toasts.map(({ id, message, type }) => (
                    <div key={id} style={{
                        padding: '8px 16px',
                        borderRadius: 4,
                        background: type === 'error' ? '#ff4d4f' : '#37d882',
                        color: 'white',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                    }}>
                        {message}
                    </div>
                ))}
            </div>
        </ToastContext.Provider>
    );
}
